
import {first} from 'rxjs/operators';
import { Component, OnInit } from "@angular/core";

import { LunaEntity, EntityMap, RelatedEntityMap } from "../../models/entity.model";
import { EntityBuilderService } from "../../services/entity-builder.service";
import { deepClone, areEqual } from "../../models/editor.model";
import { SidePanelBase } from "../../../common/components/side-panel-base.class";
import { SidePanelService } from "../../../common/services/side-panel.service";

@Component({
    templateUrl: "./workflow-entity-atlas.component.html",
    selector: "workflow-entity-atlas",
    styleUrls: ["./workflow-entity-atlas.component.scss"],
    standalone: false
})

export class WorkflowEntityAtlasComponent extends SidePanelBase implements OnInit {
    static componentName = "WorkflowEntityAtlasComponent";


    public currentEntity: LunaEntity;
    
    public initialData: any;

    entityHasChanged: boolean;

    get contextValue(): string {
        return this.componentData.contextValue;
    };

    constructor(public sidePanelService: SidePanelService, public entityService: EntityBuilderService) {
        super();
    }

    get entity() {
        return this.componentData.entityMap.entity;
    }

    set entity(value: LunaEntity) {
        this.componentData.entityMap.entity = value;
    }

    get entityMap() {
        if (this.entityService.isRelationalMap(this.componentData.entityMap)) {
            return this.componentData.entityMap as RelatedEntityMap;
        }
        return this.componentData.entityMap as EntityMap;
    }

    set entityMap(value: EntityMap | RelatedEntityMap) {
        if (this.entityService.isRelationalMap(value)) {
            this.componentData.entityMap = value as RelatedEntityMap;
        } else {
            this.componentData.entityMap = value as EntityMap;
        }
        
    }


    ngOnInit(): void {
        if (!this.componentData.relateCasingPlan) {
            this.componentData.relateCasingPlan = false;
            this.componentData.casingPlanContext = "";
            this.componentData.casingPlanRelationalProperty = "";
        }
        this.initialData = deepClone(this.componentData);
        if (this.componentData.entityMap?.entity) {
            this.entityService.get(this.componentData.entityMap.entity.id).pipe(first()).subscribe((data) => {
                this.currentEntity = data;
                this.entityHasChanged = !areEqual(this.entity, this.currentEntity);
            });
        }        
    }

    saveMap(): void {
        if (this.entityService.isRelationalMap(this.entityMap)) {
            const rel = this.entityMap as RelatedEntityMap;
            rel.isDirty = false;
        }
        this.saveMethod.emit(this.entityMap);
        this.sidePanelService.toggleSidePanel(false);
    }

    cancel(): void {
        this.componentData = deepClone(this.initialData);
        this.saveMethod.emit(null);
        this.sidePanelService.toggleSidePanel(false);
    }

    mapIsSubordinate(map: any): map is RelatedEntityMap {
        return this.entityService.isRelationalMap(map);
    }

    relateCasingPlanChanged(): void {
        if (this.entityMap.relateCasingPlan) {
            this.entityMap.casingPlanContext = "$.data.casingPlan";            
        } else {
            this.entityMap.casingPlanContext = "";            
        }
    }

    updateEntity(): void {
        this.entityMap = this.entityService.updateEntityMap(this.entityMap, this.currentEntity);
        this.entityHasChanged = !areEqual(this.entity, this.currentEntity);
    }
}